import { render } from "./SliderSection.vue?vue&type=template&id=1fd73ffd"
import script from "./SliderSection.vue?vue&type=script&lang=js"
export * from "./SliderSection.vue?vue&type=script&lang=js"

import "./SliderSection.vue?vue&type=style&index=0&id=1fd73ffd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__